import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import stxRatings from "../../../../src/data/articles/cube-prospective-strixhaven-school-of-mages/stx-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  stxRatings,
  ProspectiveIntro,
  React
};